// extracted by mini-css-extract-plugin
export default {"board":"BoardStyles_board__i-ZRS","fade-in":"BoardStyles_fade-in__bx+Hi","blur-board":"BoardStyles_blur-board__5SXk3"};